import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import { ComponentLoader } from 'components/index';
import fetch from 'features/common/fetch';

import Row from './Row';

export const ResultsTable = ({ clients, fetchState, onSelect }) => (
	<ComponentLoader fetchStorePath={fetch.constants.urls.partnerList} ignoreErrors>
		<ComponentLoader fetchStorePath={fetch.constants.urls.partner} ignoreErrors>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>
							{`${getLabelMessage('clientSearch:surname')}, ${getLabelMessage(
								'clientSearch:firstName',
							)} / ${getLabelMessage('clientSearch:businessName')}`}
						</TableCell>
						<TableCell>{getLabelMessage('clientSearch:birthDate')}</TableCell>
						<TableCell>{getLabelMessage('clientSearch:businessIn')}</TableCell>
						<TableCell>
							{`${getLabelMessage('address:address')} / ${getLabelMessage('address:house')}`}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{isNilOrEmpty(clients) ? (
						<TableHasNoResults fetchState={fetchState} />
					) : (
						clients.map((client, index) => (
							<TableRow key={index}>
								<Row client={client} onSelect={onSelect} index={index} />
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</ComponentLoader>
	</ComponentLoader>
);

ResultsTable.propTypes = {
	clients: PropTypes.array,
	fetchState: PropTypes.object,
	onSelect: PropTypes.func,
};

export default ResultsTable;
